// extracted by mini-css-extract-plugin
export const contact = "contact-module--contact--2F6Sk";
export const contact__location = "contact-module--contact__location--3qOts";
export const contact__location__text = "contact-module--contact__location__text--aDRbk";